import { useContext } from 'react';
import { StatisticsContext } from '../../views/dashboard/StatisticsProvider';

export default function useStatistics() {
  return useContext(StatisticsContext);
}
